import React from "react";

interface MobilePageLayoutProps {
  children: React.ReactNode;
  header?: React.ReactNode;
  actions?: React.ReactNode;
}

export const MobilePageLayout = ({ children, header, actions }: MobilePageLayoutProps) => (
  <div className="flex flex-col h-full overflow-hidden">
    {header}
    <div className="flex-1 overflow-y-auto min-h-0">
      {children}
    </div>
    {actions}
  </div>
);
